import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"

export default class ProviderProductionSummeryAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  //Provider Production Summery
  SummaryData = ApiRoutes.ProviderSummery.SummaryData

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }
  getSummaryByPratice = (token: string, practice_sk: any) => {
    return this.instance({
      method: this.SummaryData.Method,
      url: this.SummaryData.EndPoint(practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
}
